import React from 'react';
import { Navigate } from 'react-router-dom';
import { puedeVerModulo } from './accesoModulos';

// `modulo`: en vez de una lista de roles, usa la regla de accesoModulos.js
// (roles + usuarios puntuales). Ej.: <ProtectedRoute modulo="beneficiarios">
const ProtectedRoute = ({ allowedRoles = [], modulo, children }) => {
    const userRole = localStorage.getItem('role'); // Obtener el rol del usuario desde localStorage

    const permitido = modulo ? puedeVerModulo(modulo) : allowedRoles.includes(userRole);
    if (!permitido) {
        return <Navigate to="/" replace />; // Redirigir si no tiene permiso
    }

    return children; // Mostrar el componente si tiene permiso
};

export default ProtectedRoute;